<template>
  <div class="app-wrapper">
    <div class="main-container" :class="isCollapse?'collapse':''">
      <pang-message/>
      <app-main/>
      <app-footer/>
    </div>
  </div>
</template>

<script>
import {
  AppMain,
  AppFooter
} from './components'
import { useScreenState } from "../../store";

import {
  PangMessage
} from '../../components'

export default {
  name: 'Layout',
  components: {
    AppMain,
    AppFooter,
    PangMessage
  },
  data () {
    return {
      screenState: useScreenState(),
    }
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
  },
}
</script>

<style rel="stylesheet/scss" lang="scss">
.main-container {
    background: url(../../assets/images/bg_img_currency.jpg) repeat fixed;
    background-size: cover;
    background-position: center center;
}

.collapse {
  font-size: calc(1vw + 7px);
}

</style>
